<template>
  <el-dialog custom-class="max-dialog1256" title="优惠策略" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :modal="true" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span>优惠策略</span>
          </template>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="标题" :label-width="formLabelWidth" prop="title">
                <el-input v-model="form.title" auto-complete="off" :controls="false"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-show="!(form.customerserial&&form.customerserial=='global template')">
            <el-col :span="8" v-if="!this.forExternalDept">
              <el-form-item label="优惠规则" :label-width="formLabelWidth" prop="couponrule">
                <el-select v-model="couponrule.type" placeholder="请选择" @change="ruleChange">
                  <el-option
                    v-for="item in controlData.couponrule"
                    :key="item.value+''"
                    :label="item.text"
                    :value="item.value+''">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7" v-if="couponrule.type=='50'">
              <el-form-item label="品牌" :label-width="formLabelWidth">
                <CommonTree ref="treeCategory" :defineDataSource="true" @bindData="bindDataCategory"
                            :isShowCheckBox="false"
                            :treeHeight="200" :searchText="couponrule.categoryname"
                            :expandonclicknode="true" :onlyShowGroupType="true"
                            @check="checkCategory"></CommonTree>
              </el-form-item>
            </el-col>
            <el-col :span="7" v-if="couponrule.type!='50'&&couponrule.type!='60'">
              <p v-if="manjianvisible"><span style="color: red"><b>单片</b></span> 满
                <el-input-number v-model="couponrule.full" auto-complete="off" :controls="false" style="width:80px"></el-input-number>
                减
                <el-input-number v-model="couponrule.minus" auto-complete="off" :controls="false" style="width:80px"></el-input-number>
              </p>
              <p v-if="dazhevisible">折扣
                <el-input-number v-model="couponrule.discount" auto-complete="off" :controls="false" style="width:80px"></el-input-number>
              </p>
              <p v-show="processVisible||distributionVisible">售价
                <el-input-number v-model="couponrule.saleprice" auto-complete="off" :controls="false" style="width:80px"
                ></el-input-number>
                <span v-show="processVisible">
                面额
                <el-input-number v-model="couponrule.money" auto-complete="off" :controls="false" style="width:80px"
                ></el-input-number></span>
              </p>
            </el-col>
            <el-col :span="6" v-show="couponrule.type=='70'">
              <el-form-item label="" :label-width="formLabelWidth" prop="unique">
                <el-checkbox v-model="unique">不能与其他现金券混用</el-checkbox>
                <el-checkbox v-model="thisunique" v-if="unique">组内现金券除外</el-checkbox>
              </el-form-item>
            </el-col>
            <!--<el-col :span="6" v-if="couponrule.type!='50'&&couponrule.type!='60' && couponrule.type!='70'&& couponrule.type!='90'">-->
              <!--<p v-if="manjianvisible||dazhevisible">最大满减金额-->
                <!--<el-input-number v-model="couponrule.maxminus" auto-complete="off" :controls="false" style="width:80px"-->
                <!--&gt;</el-input-number>-->
              <!--</p>-->
            <!--</el-col>-->
            <el-col :span="6" v-if="false&&couponrule.type!='50'&&couponrule.type!='60' && couponrule.type!='70'&& couponrule.type!='90'">
              <p v-show="distributionVisible">最大购买数量
                <el-input-number v-model="couponrule.maxbuycount" auto-complete="off" :controls="false"
                                 style="width:80px"
                ></el-input-number>
              </p>
            </el-col>
          </el-row>
          <!--<el-row :gutter="24">-->
            <!--<el-col :span="24" v-show="!(couponrule.type=='50'||couponrule.type=='60')">-->
              <!--<el-form-item label="区域" :label-width="formLabelWidth" prop="area">-->
                <!--<v-distpicker :province="form.province" @province="onChangeProvince" :city="form.city"-->
                              <!--@city="onChangeCity" :area="form.county" @area="onChangeArea"></v-distpicker>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          <!--</el-row>-->
          <el-row :gutter="20"
                  v-show="!(form.customerserial&&form.customerserial=='global template')&&!forExternalDept&&!manjianvisible">
            <el-col :span="12" v-show="couponrule.type=='50'||couponrule.type=='60'">
              <el-form-item label="客户" :label-width="formLabelWidth" prop="customername">
                <AutoCustomer @clear="clearCustomerName" :content="form.customername" :size="''"
                              @handleSelect="selectExternalDept"></AutoCustomer>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="couponrule.type=='50'||couponrule.type=='60'">
              <el-form-item label="客户编码" :label-width="formLabelWidth" prop="customerserial">
                {{form.customerserial}}
              </el-form-item>
            </el-col>
            <el-col :span="6" >
              <el-form-item label="独立核算部门" :label-width="formLabelWidth">
                <el-select v-model="form.independentserial" placeholder="请选择" :clearable="true">
                  <el-option
                    :key="'all'"
                    :label="'全部适用'"
                    :value="'all'">
                  </el-option>
                  <el-option
                    v-for="item in this.idd"
                    :key="item.serialnum"
                    :label="item.dname"
                    :value="item.serialnum">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="couponrule.type=='70'||couponrule.type=='90'||couponrule.type=='50'">
              <el-form-item label="适用客户类型" :label-width="formLabelWidth">
                <el-select v-model="form.pricelevel" placeholder="请选择" :clearable="true">
                  <el-option
                    v-for="item in parameterData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-show="couponrule.type=='30'||couponrule.type=='70'||couponrule.type=='10'||couponrule.type=='20'">
              <el-form-item label="" :label-width="formLabelWidth" prop="excludespecial">
                <el-checkbox v-model="excludespecial">排除特价商品</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-show="couponrule.type=='30'">
              <el-form-item label="" :label-width="formLabelWidth" prop="forcustomer">
                <el-checkbox v-model="forcustomer">只在客户下单时使用</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <div style="float: left">
                <el-form-item label="启用时间" :label-width="formLabelWidth" prop="begindate">
                  <el-date-picker
                    v-model="form.begindate" :value-format="'yyyy-MM-dd'"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </div>
              <div style="float: left">
                <el-form-item label="" :label-width="'5px'" prop="enddate">
                  至
                  <el-date-picker
                    v-model="form.enddate" :value-format="'yyyy-MM-dd'"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="couponrule.type=='70'&&form.unitguid"><!--商品折扣-->
            <el-col :span="18">
              <el-form-item label="享受折扣" :label-width="formLabelWidth" prop="duration">
                <el-button type="warning" size="mini" plain v-on:click="goodsDiscount('60')">商品折扣</el-button>
                <el-button type="warning" size="mini" plain v-on:click="goodsDiscount('50')">品牌折扣</el-button>

                <el-table
                  :data="cashTeJia"
                  size="mini"
                  stripe
                  border
                  style="width: 100%;"
                >
                  <el-table-column
                    width="60"
                    label="序号"
                    align="center">
                    <template slot-scope="scope">
                      {{1+scope.$index}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="标题"
                    align="left"
                    header-align="center">
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="140">
                    <template slot-scope="scope">
                      <a
                        size="mini" href="javascript:void(0)"
                        @click="editCash(scope.$index, scope.row)">修改
                      </a>&nbsp;&nbsp;
                      <a
                        size="mini" href="javascript:void(0)"
                        type="danger"
                        @click="deleteCash(scope.$index, scope.row)">删除
                      </a>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="couponrule.type!='50'&&couponrule.type!='60'">
            <!--<el-col :span="12"-->
                    <!--v-if="couponrule.type!='50'&&couponrule.type!='60'&&couponrule.type!='30'&&couponrule.type!='40'&& couponrule.type!=70&& couponrule.type!=90&& couponrule.type!=80">-->
              <!--<el-form-item label="优惠方式" :label-width="formLabelWidth" prop="couponway">-->
                <!--<el-select v-model="form.couponway" placeholder="请选择" clearable>-->
                  <!--<el-option-->
                    <!--v-for="item in controlData.couponway"-->
                    <!--:key="item.value+''"-->
                    <!--:label="item.text"-->
                    <!--:value="item.value+''">-->
                  <!--</el-option>-->
                <!--</el-select>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
            <el-col :span="12" v-if="couponrule.type!='30' && couponrule.type!=70&& couponrule.type!=90">
              <el-form-item label="有效时长" :label-width="formLabelWidth" prop="duration">
                <el-input-number v-model="form.duration" auto-complete="off" :controls="false"></el-input-number>
                <span>&nbsp;&nbsp;天</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!--<el-row :gutter="24" v-if="couponrule.type!='50'&&couponrule.type!='60' && couponrule.type!='70'&& couponrule.type!='90'">-->
            <!--<el-col :span="12" v-if="couponrule.type!='30'&&couponrule.type!='40'&& couponrule.type!=80">-->
              <!--<el-form-item label="优惠券数量" :label-width="formLabelWidth" prop="couponnum">-->
                <!--<el-input-number v-model="form.couponnum" auto-complete="off" :controls="false"></el-input-number>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          <!--</el-row>-->
        </el-collapse-item>

        <el-collapse-item name="2" v-if="couponrule.type=='50'||couponrule.type=='60'">
          <template slot="title">
           <span class="titlecolor">优惠范围
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel()"
              v-if="couponrule.type=='60'">添加商品</span>
        </span>
          </template>
          <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                 v-if="couponrule.type=='60'"
                 class="query-table">
            <tr>
              <td style="background-color: #F4F4F4;text-align: center;" class="center">货品</td>
              <td style="width: 160px;background-color: #F4F4F4;  text-align: center;" class="center">货品编码</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">标准价</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">优惠方式</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">优惠数值</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">实际售价</td>
              <td style="width: 140px;background-color: #F4F4F4;  text-align: center;" class="center">操作</td>
            </tr>
            <tr v-for="(item,index) in formp">
              <td class="content">
                {{item.seedname}}
              </td>
              <td class="content">
                {{item.seedcode}}
              </td>
              <td class="content" style="text-align: right">
                {{item.costprice|numeric(2)}}
              </td>
              <td class="content">
                <el-select v-model="item.dismethod" placeholder="折扣" @change="cleatItemValue(item)">
                  <el-option label="折扣" value="0"></el-option>
                  <el-option label="固定价" value="1"></el-option>
                  <el-option label="浮动价" value="2"></el-option>
                </el-select>
              </td>
              <td class="content">
                <el-input v-model="item.discount" size="small" placeholder="输入折扣率"
                          v-if="item.dismethod=='0'"></el-input>
                <el-input v-model="item.fixmoney" size="small" placeholder="输入单价" v-if="item.dismethod=='1'"></el-input>
                <el-input v-model="item.fixmoney" size="small" placeholder="输入浮动额"
                          v-if="item.dismethod=='2'"></el-input>
              </td>
              <td class="content" style="text-align: right">
                <span v-if="item.dismethod=='0'">{{(item.costprice*item.discount*0.1)|numeric(2)}}</span>
                <span v-if="item.dismethod=='1'">{{(item.fixmoney)|numeric(2)}}</span>
                <span v-if="item.dismethod=='2'">{{(parseFloat(item.costprice||0)+parseFloat(item.fixmoney||0))|numeric(2)}}</span>
              </td>
              <td class="center content">
                <el-button v-if="item.dismethod=='1'" @click="openFixmoneyDialog(item)" type="text"
                           size="small" :style="{color: item.fixmoneybook ? '#E6A23C' : ''}">
                  光度价格{{item.fixmoneybook ? '(已设)' : ''}}
                </el-button>
                <el-button @click="deletequery(index, item)" type="text"
                           size="small">删除
                </el-button>
              </td>
            </tr>
          </table>
          <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                 v-if="couponrule.type=='50'"
                 class="query-table">
            <tr>
              <td style="width:150px;background-color: #F4F4F4;text-align: center;" class="center">下单方式</td>
              <td style="width: 80px;background-color: #F4F4F4;  text-align: center;" class="center">折扣</td>
            </tr>
            <tr v-for="(item,index) in filltemplate">
              <td class="content">
                {{item.name}}
              </td>
              <td class="content">
                <el-input v-model="item.discount" placeholder="请输入折扣" v-on:blur="inputFunc(item)"></el-input>
              </td>
            </tr>
          </table>

        </el-collapse-item>

        <el-collapse-item name="3" v-if="couponrule.type=='70'|| couponrule.type=='20'||couponrule.type=='10'">
          <template slot="title" style="display: inline-block;">
        <span class="titlecolor">使用范围
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(0)">添加商品</span>
          <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodCategorySel" v-if="!manjianvisible">添加类别</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;"
            >
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="产品类别"
                align="left"
                header-align="center"
                width="170">
                <template slot-scope="scope">
                  {{!scope.row.seedcode?scope.row.categorycode+' '+scope.row.categoryname:scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="产品名称"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <a
                    size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="3" v-if="couponrule.type=='90'">
          <template slot="title" style="display: inline-block;">
        <span class="titlecolor">套餐内容
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(0)">添加商品</span>
          <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodCategorySel">添加类别</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;"
            >
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="产品类别"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  {{!scope.row.seedcode?scope.row.categorycode+' '+scope.row.categoryname:scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="产品名称"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column label="单价" align="center" width="140">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.fixmoney" :min="0" :precision="2" auto-complete="off" :controls="false" style="width:100px"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="数量" align="center" width="140">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.discount" :min="1" :precision="0" auto-complete="off" :controls="false" style="width:100px"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="总价" align="center" width="140">
                <template slot-scope="scope">
                    {{(scope.row.fixmoney|0.00)*(scope.row.discount|0.00)}}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <a
                    size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="4" v-if="false">
          <template slot="title" style="display: inline-block;">
        <span class="titlecolor">特价商品
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(1)">添加商品</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableDataSkim"
              size="mini"
              stripe
              border
              style="width: 100%;"
            >
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="产品类别"
                align="left"
                header-align="center"
                width="170"
              >
                <template slot-scope="scope">
                  {{!scope.row.seedcode?scope.row.categorycode+' '+scope.row.categoryname:scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="产品名称"
                align="left"
                header-align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <a
                    size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                    type="danger"
                    @click="handleDeleteSkim(scope.$index, scope.row)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
        <!--<el-collapse-item name="5">-->
          <!--<template slot="title">-->
           <!--<span class="titlecolor">简介-->
        <!--</span>-->
          <!--</template>-->
          <!--<el-row>-->
            <!--<el-col :span="24">-->
              <!--<el-form-item prop="describe">-->
                <!--<QuillEditor ref="refdiscrip" :content="form.describe"-->
                             <!--@on-content-change="changeDiscrip"></QuillEditor>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          <!--</el-row>-->
        <!--</el-collapse-item>-->
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!--<el-button-->
      <!--size="mini"-->
      <!--type="danger"-->
      <!--@click="handleDeleteFavour()"-->
      <!--v-if="!(form.customerserial&&form.customerserial=='global template')&&!form.contractguid&&form.unitguid">删除-->
    <!--</el-button>-->
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" v-if="!(form.contractguid||cannotadd)" :loading="loading">确 定</el-button>
      <span style="color: red" v-if="form.contractguid||cannotadd">只能在销售合同中修改！</span>
      <span v-if="form.unitguid" @click="handleloglook" style="position: absolute;bottom: 25px;right: 10px">(修改日志)</span>
    </div>
    <JxcgooddetailSel ref="JxcgooddetailSel" :isShowCheckBox="true"
                      @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <SaleFavourEditlog ref="SaleFavourEditlog"></SaleFavourEditlog>
    <JxcgoodscategorySel ref="JxcgoodscategorySel" :isShowCheckBox="true"
                         @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
    <SaleFavourCopy ref="SaleFavourCopy" @bindGrid="initData"></SaleFavourCopy>
    <el-dialog title="光度价格设置" :visible.sync="fixmoneyDialogVisible"
               :append-to-body="true" :close-on-click-modal="false"
               custom-class="max-dialog" center>
      <div style="margin-bottom: 10px;">
        <el-button size="mini" type="warning" @click="initFixmoneyBook" v-if="fixmoneyVisible">初始化</el-button>
        <el-button size="mini" type="danger" @click="clearFixmoneyBook" v-if="fixmoneyVisible">清空</el-button>
        <el-button type="warning" size="mini" plain @click="importFixmoney" v-if="fixmoneyVisible">二维表导入</el-button>
        <el-button size="mini" @click="exportFixmoney" v-if="fixmoneyVisible">导出Excel</el-button>
        <input type="file" ref="fixmoneyFileInput" style="display: none;" @change="changeFixmoneyFile($event)"/>
        <span v-if="!fixmoneyVisible" style="color: #999; font-size: 12px;">该商品不支持光度二维表设置</span>
      </div>
      <TwoDimensionalTable ref="fixmoneyTable" v-if="fixmoneyVisible"
                           :isShowTotalNumber="false" :erweitable="fixmoneyErweitable"
                           :needSetUnion="true" :cutHeight="308">
      </TwoDimensionalTable>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fixmoneyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFixmoneyBook" v-if="fixmoneyVisible">确 定</el-button>
        <el-button type="primary" @click="fixmoneyDialogVisible = false" v-if="!fixmoneyVisible">关 闭</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>


<script>
  import {saveData, getDetail, deleteData,getControlData, getCouponWay, getCouponRule} from '@/api/set/salefavour';

  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getPrice} from '@/api/set/goodsprice';
  import JxcgoodscategorySel from '../../set/jxcgoodscategory/JxcgoodscategorySel'
  import {independentDept} from '@/api/set/dept';
  import {getGoodsDetail} from '@/api/set/jxcgoodscategory';
  import {list4PriceSet} from '@/api/set/jxcgooddetail';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel'
  import {getParameterDetail} from '@/api/set/parameter';
  import QuillEditor from '../../common/QuillEditor'
  import SaleFavourEditlog from './SaleFavourEditlog'
  import SaleFavourCopy from './SaleFavourCopy'
  import TwoDimensionalTable from '../goodsprice/TwoDimensionalTable'
  import {checkCustomerserial} from '@/api/set/accountageset';

  export default {
    name: "SaleFavourEdit",
    data() {

      return {
        loading: false,//防止多次提交
        tableData: [],
        cannotadd:false,
        tableDataSkim: [],//特价商品
        formp: [],
        dialogFormVisible: false,
        activeNames: ['1', '2', '3', '4', '5'],
        idd: [],
        dazhevisible: false,
        manjianvisible: false,
        processVisible: false,
        distributionVisible: false,
        customername: '',
        isSkim: 0,//1表示特价商品
        excludespecial: true,
        unique:true,
        thisunique:false,
        forcustomer:false,
        cashTeJia:[],
        fixmoneyDialogVisible: false,
        fixmoneyDialogItem: null,
        fixmoneyBookContent: [],
        fixmoneyCostPriceBook: {},
        fixmoneyErweitable: [],
        fixmoneyVisible: false,
        couponrule: {
          type: '',
          full: '',
          minus: '',
          discount: '',
          saleprice: '',
          forcustomer:false,//只在客户下单时启用
          money: '',
          maxbuycount: '',
          categorycode: "",
          categoryname: "",
          filltemplate: {},
          excludespecial: false,
          unique:true,
          thisunique:false,
        },
        wayFlag: true,
        filltemplate: [
          {name: "现片", value: '10', discount: ""},
          {name: "定制片",value: '20',discount: ""},
          {name: "区分左右眼", value: '30', discount: ""},
          {name: "镜架", value: '80', discount: ""},
          {name: "数量选择", value: '40', discount: ""},
          {name: "加工",value: '50',discount: ""},
          {name: "特殊加工", value: '60', discount: ""}
        ],
        form: {
          unitguid: "",
          begindate: "",
          enddate: "",
          customerserial: "",
          customername: "",
          independentserial: '',
          pricelevel: '',
          salefavouedetail: "",
          province: "",
          city: "",
          county: "",
          couponway: '',
          couponrule: "",
          duration: "",
          couponnum: "",
          title: "",
          contractguid:"",
          describe: ""
        },
        controlData: {
          couponway: [],
          couponrule: []
        },
        parameterData: [],
        formLabelWidth: '120px',
        rules: {
          enddate: [
            {required: true, message: '请填写结束日期', trigger: 'blur'},
          ],
          begindate: [
            {required: true, message: '请填写开始日期', trigger: 'blur'},
          ],
        },
      }
    },
    props: {
      forExternalDept: {
        defalut: false//设置客户的时候启用
      }
    },
    methods: {
      handleDeleteFavour() {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({unitguid: this.form.unitguid}).then(response => {
            if (response.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.dialogFormVisible = false;
              //刷新列表
              this.$emit('bindGrid');

            }else{
              this.$message({
                type: 'error',
                message: response.data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      //输入框校验，只能输入小数和数字
      inputFunc(item) {
        if (item.discount && "" != item.discount.replace(/^\d+$|^\d*\.\d+$/g, '')) {
          this.$message({
            message: '请输入正确的数字',
            type: 'error'
          })
          item.discount = ''
        }
      },
      //查看处理日志
      handleloglook() {
        this.$refs.SaleFavourEditlog.show()
        this.$refs.SaleFavourEditlog.initData(this.form.unitguid);
      },
      goodsDiscount(type) {
        this.$refs.SaleFavourCopy.initPara(this.parameterData);
        this.$refs.SaleFavourCopy.show(type, this.form.unitguid);
      },
      editCash(index, row) {
        this.$refs.SaleFavourCopy.initPara(this.parameterData);
        this.$refs.SaleFavourCopy.initData(row.unitguid)
        this.$refs.SaleFavourCopy.show();
      },
      deleteCash(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({unitguid: row.unitguid}).then(response => {
            this.initData(this.form.unitguid);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      cleatItemValue(item) {
        item.discount = '';
        item.fixmoney = '';
        item.fixmoneybook = null;
      },
      changeDiscrip(val) {
        this.form.describe = val
      },
      getCustomPrice() {
        if (this.form.customerserial == '' || !'60' == this.couponrule.type.toString() || this.formp.length == 0)
          return;
        var seedcodelist = '';
        for (var i = 0; i < this.formp.length; i++) {
          seedcodelist += this.formp[i].seedcode + ';';
          if (!this.formp[i].dismethod)
            this.formp[i].dismethod = '0';
          else
            this.formp[i].dismethod = this.formp[i].dismethod.toString();
        }
        list4PriceSet({customguid: this.form.customerserial, seedcodelist: seedcodelist}).then(response => {
          var items = response.data.obj;
          for (var i = 0; i < items.length; i++) {

            for (var j = 0; j < this.formp.length; j++) {
              if (this.formp[j].seedcode == items[i].seedcode) {
                if (items[i].prices.length > 0)
                  this.formp[j].costprice = items[i].prices[0].costprice;
                else
                  this.formp[j].costprice = 0;
              }
            }
          }
        })
      },
      //删除明细
      handleDelete(index, row) {
        //如果删除的是类别，则要判断此类别下面是否有特价商品，如果有，则必须先删除特价商品才能删除此类别
        if (!row.seedcode) {
          for (let i in this.tableDataSkim) {
            if (this.tableDataSkim[i].categorycode.startsWith(row.categorycode)) {
              this.$message({
                message: "该类别下存在特价商品，无法删除该类别",
                type: 'warning',
                duration: 1500
              })
              return
            }
          }
        }
        this.tableData.splice(index, 1)
      },
      //删除特价商品
      handleDeleteSkim(index, row) {
        this.tableDataSkim.splice(index, 1)
      },
      //选择商品类别
      showGoodCategorySel(arr) {
        this.$refs.JxcgoodscategorySel.show()
      },
      //显示商品选择页面
      showGoodDetailSel(isSkim) {
        this.isSkim = isSkim
        this.$refs.JxcgooddetailSel.show()
      },
      //选择按商品折扣执行
      afterSelectCodeByGoods(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          var exists = false;
          for (let j in this.formp) {
            //判读该商品是否已经存在
            if (this.formp[j].seedcode == arr[i].seedcode) {
              exists = true;
              break;
            }
          }
          if (!exists) {
            this.formp.push({
              categorycode: arr[i].categorycode,
              categoryname: arr[i].categoryname,
              costprice: null,
              discount: null,
              dismethod: '0',
              fixmoney: null,
              fixmoneybook: null,
              isskim: null,
              parentguid: null,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              tenantid: null,
              unitguid: null
            });
          }
        }
        this.getCustomPrice();
      },
      //选择特价商品之后执行
      afterSelectSkim(arr) {
        let count = 0;
        let i = this.tableDataSkim.length
        label1:
          for (let i in arr) {
            let biaoji = 0
            for (let j in this.tableDataSkim) {
              //判读该特价商品是否已经添加
              if (this.tableDataSkim[j].seedcode == arr[i].seedcode) {
                biaoji = 1
                count++
                continue label1
              }
            }

            if (biaoji == 0) {
              //判断该特价商品不能是合同明细中的商品
              for (let g in this.tableData) {
                if (this.tableData[g].seedcode && arr[i].seedcode == this.tableData[g].seedcode) {
                  biaoji = 1
                  count++
                  continue label1
                }
              }
            }

            if (biaoji == 0) {
              let temp = 0
              for (let g in this.tableData) {
                //判读特价的商品必须属于合同明细下的类别
                if (!this.tableData[g].seedcode && arr[i].categorycode.startsWith(this.tableData[g].categorycode)) {
                  temp = 1
                  this.tableDataSkim.push({
                    isskim: 1,
                    categoryname: arr[i].lname,
                    seedcode: arr[i].seedcode,
                    seedname: arr[i].seedname,
                    categorycode: arr[i].categorycode
                  })
                  break
                }
              }
              if (temp == 0) {
                count++
              }
            }
          }
        if (count > 0) {
          this.$message({
            message: "该特价商品已存在，或者合同明细中已存在，或者不属于合同明细类别下的商品",
            type: 'info'
          })
        }
      },

      //选择商品之后执行
      afterSelectCode(arr) {
        if (this.couponrule.type == '60') {//按商品折扣
          this.afterSelectCodeByGoods(arr)
          return
        }
        if (this.isSkim == 1) {
          this.afterSelectSkim(arr)
          return
        }
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if ((!this.tableData[j].seedcode && arr[i].categorycode.startsWith(this.tableData[j].categorycode)) || (this.tableData[j].seedcode && this.tableData[j].seedcode == arr[i].seedcode
            )) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              categoryname: arr[i].lname,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              categorycode: arr[i].categorycode
            })
          }
        }
        if (count > 0) {
          this.$message({
            message: "商品已存在，或者属于已选择类别下的商品",
            type: 'info'
          })
        }
      },
      afterSelectCategoryCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            if ((!this.tableData[j].seedcode && (arr[i].categorycode.startsWith(this.tableData[j].categorycode) || this.tableData[j].categorycode.startsWith(arr[i].categorycode)) && arr[i].categorycode != this.tableData[j].categorycode) || (this.tableData[j].seedcode && this.tableData[j].categorycode.startsWith(arr[i].categorycode))) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({categorycode: arr[i].categorycode, categoryname: arr[i].categoryname})
          }
        }
        if (count > 0) {
          this.$message({
            message: "该商品类别已经存在父类别、子类别或该类别下的商品",
            type: 'info'
          })
        }
      },
      clearDate() {
        this.dazhevisible = false
        this.manjianvisible = false
        this.processVisible = false;
        this.distributionVisible = false;
      },
      clearCouponrule() {
        this.couponrule.full = ''
        this.couponrule.minus = ''
        this.couponrule.discount = ''
        this.couponrule.saleprice = ''
        this.couponrule.money = ''
        this.couponrule.maxbuycount = ''
        this.couponrule.categorycode = ""
        this.couponrule.categoryname = ""
        this.couponrule.filltemplate = {}
        this.excludespecial = true;
        this.unique = true;
        this.thisunique=false;
        this.forcustomer = false;
      },
      ruleChange() {
        this.clearCouponrule()
        if ('10' == this.couponrule.type) {//满减券
          this.dazhevisible = false;
          this.manjianvisible = true;
          this.processVisible = false;
          this.distributionVisible = false;
          this.disabled = true
        } else if ('20' == this.couponrule.type) {//折扣券
          this.dazhevisible = true;
          this.manjianvisible = false;
          this.processVisible = false;
          this.distributionVisible = false;
          this.disabled = true
        } else if ('30' == this.couponrule.type) {//加工券
          this.dazhevisible = false;
          this.manjianvisible = false;
          this.distributionVisible = true;
          this.processVisible = true;
          this.disabled = true
        } else if ('40' == this.couponrule.type || '80' == this.couponrule.type) {//配送券
          this.dazhevisible = false;
          this.manjianvisible = false;
          this.processVisible = false;
          this.distributionVisible = true;
          this.disabled = true
        } else if ('50' == this.couponrule.type || '60' == this.couponrule.type) {//按商品分类折扣、按商品折扣
          this.couponrule.discount = ""
          this.couponrule.money = ""
          this.couponrule.minus = ""
          this.couponrule.maxminus = ""
          this.couponrule.maxbuycount = ""
          this.couponrule.saleprice = ""
          this.disabled = false
          this.rules = {
            enddate: [
              {required: true, message: '请填写结束日期', trigger: 'blur'},
            ],
            begindate: [
              {required: true, message: '请填写开始日期', trigger: 'blur'},
            ]
          }
        } else if ('70' == this.couponrule.type) {//现金抵扣券
          this.disabled = true
          this.dazhevisible = false;
          this.manjianvisible = false;
          this.processVisible = true;
          this.distributionVisible = true;
        } else if ('90' == this.couponrule.type) {//销售套餐
          this.disabled = true
          this.dazhevisible = false;
          this.manjianvisible = false;
          // this.processVisible = true;
          this.distributionVisible = false;
        }
        //初始化校验
        if ('50' != this.couponrule.type && '60' != this.couponrule.type) {
          this.rules = {
            enddate: [
              {required: true, message: '请填写结束日期', trigger: 'blur'},
            ],
            begindate: [
              {required: true, message: '请填写开始日期', trigger: 'blur'},
            ]
          }
        }
        this.loading = false;
      },
      clearCustomerName() {
        this.form.customerserial = "";
        this.form.customername = "";
        this.customername = "";
        this.cannotadd = false;
      },
      selectExternalDept(customerserial, deptname, row) {
        this.form.customerserial = customerserial;
        this.form.customername = deptname;
        this.customername = deptname;
        if (customerserial) {
          checkCustomerserial({customerserial: customerserial}).then(response => {
            this.cannotadd = response.data.code == 0;
          });
        }
        this.getCustomPrice();
      },
      deletequery(index, row) {
        this.formp.splice(index, 1)
      },
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.form.province = data.value;
      },
      onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.form.city = data.value;
      },
      onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        this.form.county = data.value;
      },
      checkCategory(guids, names, arr) {
        this.$set(this.couponrule, "categorycode", guids)
        this.$set(this.couponrule, "categoryname", names)
      },
      bindDataCategory() {
        this.$refs.treeCategory.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true})
        })
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({})
        })
      },
      show() {
        this.dialogFormVisible = true;
      },
      saveData() {
        this.loading = true;
        this.$refs.form1.validate((valid) => {
          if (valid) {
            //参数校验
            if (this.couponrule.type == '40') {
              if (this.form.duration <= 0) {
                this.$message({
                  message: '请正确设置有效时长',
                  type: 'warning'
                });
                this.loading = false
                return;
              }
            } else if (this.couponrule.type == '70') {//现金抵扣券 设置了范围的 不需要判断是否特价
              if (this.excludespecial && this.tableData.length > 0 && this.cashTeJia.length > 0) {
                this.excludespecial = false;
              }
            } else if (this.couponrule.type == '90') {
              if (this.tableData.length == 0) {
                this.$message({message: '请设置套餐内容！', type: 'warning'});
                this.loading = false
                return;
              }
              var totalmoney = 0;
              for (let i in this.tableData) {
                var row = this.tableData[i];
                if (row.fixmoney == undefined || row.fixmoney == null) {
                  this.$message({message: '单价必填！', type: 'warning'});
                  this.loading = false
                  return;
                }
                if (row.discount == undefined || row.discount == null) {
                  this.$message({message: '数量必填！', type: 'warning'});
                  this.loading = false
                  return;
                }
                totalmoney += parseFloat(row.fixmoney) * parseFloat(row.discount);
              }
              if (totalmoney <= 0) {
                this.$message({message: '套餐总额必须大于0！', type: 'warning'});
                this.loading = false
                return;
              }
              this.couponrule.money = totalmoney;
              this.couponrule.saleprice = totalmoney;
            }

            this.couponrule.excludespecial = this.excludespecial;
            this.couponrule.unique = this.unique;
            this.couponrule.thisunique=this.thisunique;
            this.couponrule.forcustomer = this.forcustomer;
            if (this.couponrule.type == '60') {
              var text = JSON.stringify(this.formp);
              for (var i = 0; i < this.formp.length; i++) {
                var num = this.formp[i].discount;
                var fixmoney = this.formp[i].fixmoney;

                if (this.formp[i].dismethod == '1' && !this.formp[i].fixmoneybook && (fixmoney === null || fixmoney === undefined || fixmoney === '')) {
                  //注意：不能写 fixmoney == '' —— JS中 0=='' 为true，优惠到0(固定单价0)是允许的
                  this.$message({message: '请输入固定单价', type: 'warning'});
                  this.loading = false
                  return;
                } else if (this.formp[i].dismethod == '2' && (fixmoney === null || fixmoney === undefined || fixmoney === '')) {
                  this.$message({message: '请输入浮动价', type: 'warning'});
                  this.loading = false
                  return;
                } else if (this.formp[i].dismethod == '0' && (num === null || num === undefined || num === '')) {
                  this.$message({message: '请输入折扣价', type: 'warning'});
                  this.loading = false
                  return;
                }
              }
              this.form.salefavouedetail = text;
            }


            let begindate = new Date(this.form.begindate).getTime()
            let enddate = new Date(this.form.enddate).getTime()
            if (begindate > enddate) {
              this.$message({
                message: '开始日期不能大于结束日期',
                type: 'warning'
              });
              this.loading = false
              return;
            }

            if (this.couponrule.type == '10' || this.couponrule.type == '20' || this.couponrule.type == '70' || this.couponrule.type == '90') {
              this.form.salefavouedetail = JSON.stringify(this.tableData.concat(this.tableDataSkim));
            }
            if (this.couponrule.type == '50') {
              let tempobj = {}
              this.filltemplate.forEach(o => {
                tempobj[o["value"]] = o["discount"]
              })
              this.$set(this.couponrule, "filltemplate", tempobj)
            } else {
              delete this.couponrule.filltemplate
              delete this.couponrule.categorycode
              delete this.couponrule.categoryname
            }


            this.form.couponrule = JSON.stringify(this.couponrule);

            this.form.externaldeptDO = {}
            saveData(this.form).then(response => {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.dialogFormVisible = false;
              //刷新列表
              this.$emit('bindGrid');
            });
          } else {
            this.loading = false
          }
        })
      },
      initData(unitguid) {
        this.initForm();
        getDetail({unitguid: unitguid}).then(response => {
          this.formp = response.data.obj.saleList;

          this.form = response.data.obj;
          if (response.data.obj.externaldeptDO !== null) {
            this.form.customername = response.data.obj.externaldeptDO.deptname
            this.customername = response.data.obj.externaldeptDO.deptname
          }
          if (this.form.couponrule) {
            this.couponrule = JSON.parse(this.form.couponrule);
            this.excludespecial = this.couponrule.excludespecial;
            this.unique = this.couponrule.unique ? true : false;
            this.thisunique= this.couponrule.thisunique ? true : false;
            this.forcustomer = this.couponrule.forcustomer ? true : false;
            if ('10' == this.couponrule.type) {
              response.data.obj.saleList.forEach(o => {
                if (o.isskim == 1) {
                  this.tableDataSkim.push(o)
                } else {
                  this.tableData.push(o)
                }
              })
              this.dazhevisible = false
              this.processVisible = false;
              this.distributionVisible = false;
              this.manjianvisible = true
            }
            else if ('20' == this.couponrule.type) {
              response.data.obj.saleList.forEach(o => {
                if (o.isskim == 1) {
                  this.tableDataSkim.push(o)
                } else {
                  this.tableData.push(o)
                }
              })
              this.dazhevisible = true;
              this.processVisible = false;
              this.distributionVisible = false;
              this.manjianvisible = false
            }
            else if ('30' == this.couponrule.type) {
              this.dazhevisible = false;
              this.processVisible = true;
              this.distributionVisible = false;
              this.manjianvisible = false
            }
            else if ('40' == this.couponrule.type) {
              this.dazhevisible = false;
              this.processVisible = false;
              this.distributionVisible = true;
              this.manjianvisible = false
            } else if ('50' == this.couponrule.type) {
              this.filltemplate = []
              if (this.couponrule.filltemplate) {
                for (let i in this.couponrule.filltemplate) {
                  if (i == '10')
                    this.filltemplate.push({name: "现片", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '20')
                    this.filltemplate.push({name: "定制片", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '30')
                    this.filltemplate.push({name: "区分左右眼", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '80')
                    this.filltemplate.push({name: "镜架", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '40')
                    this.filltemplate.push({name: "数量选择", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '50')
                    this.filltemplate.push({name: "加工", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '60')
                    this.filltemplate.push({name: "特殊加工", value: i, discount: this.couponrule.filltemplate[i]})
                }
              }

            } else if ('60' == this.couponrule.type) {//按商品折扣
              this.getCustomPrice();
            } else if ('70' == this.couponrule.type) {
              this.dazhevisible = false;
              this.processVisible = true;
              this.distributionVisible = true;
              this.manjianvisible = false
              this.cashTeJia = response.data.tejia;
              response.data.obj.saleList.forEach(o => {
                if (o.isskim == 1) {
                  this.tableDataSkim.push(o)
                } else {
                  this.tableData.push(o)
                }
              })
            } else if ('90' == this.couponrule.type) {
              this.dazhevisible = false;
              this.processVisible = false;
              this.distributionVisible = false;
              this.manjianvisible = false
              this.cashTeJia = response.data.tejia;
              response.data.obj.saleList.forEach(o => {
                if (o.isskim == 1) {
                  this.tableDataSkim.push(o)
                } else {
                  this.tableData.push(o)
                }
              })
            }

          }
        })
      },
      initForm() {
        this.costprice = ''
        this.loading = false;
        this.cannotadd = false;
        this.filltemplate = [{name: "现片", value: '10', discount: ""},
          {name: "定制片", value: '20', discount: ""},
          {name: "区分左右眼", value: '30', discount: ""},
          {name: "镜架", value: '80', discount: ""},
          {name: "数量选择", value: '40', discount: ""},
          {name: "加工", value: '50', discount: ""},
          {name: "特殊加工", value: '60', discount: ""}]
        this.dazhevisible = false
        this.manjianvisible = false
        this.couponrule = {type: '', full: '', minus: '', discount: '', saleprice: '', money: '', maxbuycount: ''}
        // this.query = [{"full": "", "give": ""}],
        this.tableData = []
        this.tableDataSkim = []
        this.allowselectrule = true,
          this.formp = [];
        this.form = {};
        this.fixmoneyDialogVisible = false;
        this.fixmoneyDialogItem = null;
        this.fixmoneyBookContent = [];
        this.fixmoneyCostPriceBook = {};
        this.fixmoneyErweitable = [];
        this.fixmoneyVisible = false;
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        if (this.$refs.treeSeed != undefined) {
          this.$refs.treeSeed.reset();
        }
        if (this.$refs.treeCategory != undefined) {
          this.$refs.treeCategory.reset();
        }
        this.form.customername = '';
        this.customername = "";
        if (this.forExternalDept)
          this.couponrule.type = '50';
      },
      //打开光度价格设置对话框
      openFixmoneyDialog(item) {
        this.fixmoneyDialogItem = item;
        this.fixmoneyBookContent = [];
        this.fixmoneyCostPriceBook = {};
        this.fixmoneyErweitable = [];
        this.fixmoneyVisible = false;
        this.fixmoneyDialogVisible = true;
        //获取光度范围
        getPrice({seedcode: item.seedcode, onlyRange: true}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            this.fixmoneyCostPriceBook = response.data.obj;
            this.fixmoneyVisible = true;
          } else {
            this.fixmoneyCostPriceBook = {};
          }
          //恢复已有数据
          if (item.fixmoneybook) {
            try {
              var parsed = JSON.parse(item.fixmoneybook);
              if (parsed && parsed.BookContent) {
                this.fixmoneyBookContent = parsed.BookContent;
              }
            } catch (e) {
              this.fixmoneyBookContent = [];
            }
          }
          this.$nextTick(() => {
            if (this.$refs.fixmoneyTable) {
              this.$refs.fixmoneyTable.initBook(this.fixmoneyCostPriceBook, this.fixmoneyBookContent, '');
            }
          });
        });
      },
      //一键初始化光度价格
      initFixmoneyBook() {
        if (this.$refs.fixmoneyTable) {
          this.$refs.fixmoneyTable.initForm();
          var defaultVal = this.fixmoneyDialogItem.fixmoney || '';
          this.$refs.fixmoneyTable.initBook(this.fixmoneyCostPriceBook, this.fixmoneyBookContent, defaultVal);
        }
      },
      //清空光度价格
      clearFixmoneyBook() {
        if (this.$refs.fixmoneyTable) {
          this.$refs.fixmoneyTable.initForm();
        }
        this.fixmoneyBookContent = [];
        this.fixmoneyDialogItem.fixmoneybook = null;
      },
      //二维表导入
      importFixmoney() {
        this.$refs.fixmoneyFileInput.value = "";
        this.$refs.fixmoneyFileInput.click();
      },
      //导出二维表Excel
      exportFixmoney() {
        if (this.$refs.fixmoneyTable) {
          this.$refs.fixmoneyTable.getExcel(this.fixmoneyDialogItem.seedcode || '光度价格');
        }
      },
      changeFixmoneyFile(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/;
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！");
            return;
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = [];
            if (typeof data == "object" && (Array.isArray(data) || data instanceof Array)) {
              let obj = {};
              data.forEach((item) => {
                let Y = "";
                for (let X in item) {
                  obj = {};
                  if (X == "球\\柱") {
                    Y = parseFloat(item[X]).toFixed(2);
                  } else {
                    if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                      obj = {"X": parseFloat(X).toFixed(2), "Y": Y, "P": parseFloat(item[X])};
                      arr.push(obj);
                    }
                  }
                }
              });
            }
            this.fixmoneyBookContent = arr;
            if (this.$refs.fixmoneyTable) {
              this.$refs.fixmoneyTable.initBook(this.fixmoneyCostPriceBook, arr, null, null);
            }
          });
        } catch (e) {
          this.$message.error("导入失败");
        }
      },
      //保存光度价格到当前行
      saveFixmoneyBook() {
        var arr = [];
        if (this.fixmoneyErweitable) {
          for (let i in this.fixmoneyErweitable) {
            let temp = this.fixmoneyErweitable[i].filter(t => {
              return typeof (t.P) != "undefined" && t.P !== "";
            });
            arr = arr.concat(temp);
          }
        }
        if (arr.length == 0) {
          //没有设置任何价格，视为清空
          this.fixmoneyDialogItem.fixmoneybook = null;
        } else {
          this.fixmoneyDialogItem.fixmoneybook = JSON.stringify({BookContent: arr});
        }
        this.fixmoneyDialogVisible = false;
      },
    },
    mounted() {
      getParameterDetail({paraname: "客户价格等级"}).then(response => {
        this.parameterData = JSON.parse(response.data.obj.paracontent);
      });
      independentDept().then(response => {
        this.idd = response.data.obj
      });
      getCouponWay().then(response => {
        this.controlData.couponway = response.data.obj
      })
      getCouponRule().then(response => {
        this.controlData.couponrule = response.data.obj
      })
    },
    components: {
      JxcgooddetailSel,
      QuillEditor,
      JxcgoodscategorySel,
      SaleFavourCopy,
      SaleFavourEditlog,
      TwoDimensionalTable
    },
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .center {
    text-align: center;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/salefavour/SaleFavourEdit.vue